import { render, staticRenderFns } from "./WysiwygHtmlArea.vue?vue&type=template&id=2ae634f7"
import script from "./WysiwygHtmlArea.ts?vue&type=script&lang=ts&external"
export * from "./WysiwygHtmlArea.ts?vue&type=script&lang=ts&external"
import style0 from "./WysiwygHtmlArea.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports